// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__G7KCX","socialButtons":"Login_socialButtons__xu7ms","socialButton":"Login_socialButton__3Kfy1","icon":"Login_icon__1IEI-"};